var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo",class:_vm.inline ? 'inline' : ''},[_c('img',{staticClass:"img-responsive",attrs:{"src":require("../assets/logo-white.png"),"alt":"kiosk access portal"}}),_c('span',{staticClass:"logo-text"},[_vm._v("KIOSK")])])
}
var staticRenderFns = []

export { render, staticRenderFns }